'use client'

import Link from 'next/link'
import { useSession } from 'next-auth/react'
import { FglHeader } from '@/components/layout/fgl-header'
import { useTranslation } from '@/i18n/client'
import {
  LenisProvider,
  Reveal,
  Magnetic,
  LivingThermal,
  GliderBackdrop, GliderOrbit,
} from '@/components/award'

export default function NotFound() {
  const { t } = useTranslation()
  const { data: session } = useSession()
  const isLoggedIn = !!session?.user

  return (
    <LenisProvider>
      <div data-award="true" className="relative min-h-screen flex flex-col" style={{ background: 'var(--award-ink)' }}>
        <FglHeader />
      <GliderBackdrop />

        <main className="relative flex-1 flex items-center justify-center overflow-hidden pt-[84px] pb-16">
          <div className="relative z-10 max-w-[900px] mx-auto px-6 md:px-12 text-center">
            <Reveal>
              <div className="flex items-center justify-center gap-3 mb-6 flex-wrap">
                <span className="award-eyebrow">404 · Off Course</span>
                <span className="h-px w-16 bg-[var(--award-line-hi)]" />
                <span className="award-label">{t('notFound.trailEnds')}</span>
              </div>
            </Reveal>

            <Reveal delay={1}>
              <h1
                className="font-bold leading-none mb-4"
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: 'clamp(120px, 22vw, 280px)',
                  letterSpacing: '-0.06em',
                  color: 'var(--award-gold)',
                  textShadow: '0 8px 40px var(--award-gold-glow)',
                }}
              >
                404
              </h1>
            </Reveal>

            <Reveal delay={2}>
              <h2 className="award-h-lg mb-4">
                {t('notFound.heading')}
              </h2>
            </Reveal>

            <Reveal delay={3}>
              <p className="award-body-lead mx-auto mb-10">
                {t('notFound.message')}
              </p>
            </Reveal>

            <Reveal delay={4}>
              <div className="flex gap-4 justify-center flex-wrap">
                <Magnetic>
                  <Link href="/" className="award-btn award-btn-primary">
                    {t('notFound.goHome')} <span aria-hidden>→</span>
                  </Link>
                </Magnetic>
                {isLoggedIn && (
                  <Magnetic>
                    <Link href="/app" className="award-btn award-btn-ghost">
                      {t('notFound.goDashboard')}
                    </Link>
                  </Magnetic>
                )}
              </div>
            </Reveal>
          </div>
        </main>
      </div>
    </LenisProvider>
  )
}
